var path = 'app/scripts/modules/core/src/help/helpField.popover.html';
var html = "<div\n  ng-mouseenter=\"$ctrl.popoverHovered()\"\n  ng-mouseleave=\"$ctrl.hidePopover(false)\"\n  ng-bind-html=\"$ctrl.contents.content\"\n></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;